export var ButtonTypeEnum;
(function (ButtonTypeEnum) {
    ButtonTypeEnum["PRIMARY"] = "primary";
    ButtonTypeEnum["SECONDARY"] = "secondary";
    ButtonTypeEnum["CLICKED"] = "clicked";
})(ButtonTypeEnum || (ButtonTypeEnum = {}));
